<template>
  <div class="jin-m-index jin-m">
    <div class="jin-m-container jin-index-con">
      <Common :is-pc="false" />
      <!-- <p class="jin-m-index-check" @click="$router.push('list?attributes=1')">查看在招职位 <Icon name="arrow-right" /></p> -->
      <div class="bottom-arrow">
        <img class="float-Y" src="~@/assets/index/向上滑动@2x.png" alt="">
        <div>向上滑动</div>
        <img class="video-play" src="~@/assets/index/播放视频@2x.png" @click="isShowVideo = true">
      </div>
    </div>
    <Hvideo :is-show-video.sync="isShowVideo" />
    <ZpTypeNav />
    <Product />
    <Welfare />
    <Activity />
    <JoinUs />
  </div>
</template>

<script>
import Common from './common'
import ZpTypeNav from './mobile/zpTypeNav'
import Product from './mobile/product'
import Welfare from './mobile/welfare'
import Activity from './mobile/activity'
import Hvideo from '@/components/Hvideo'
import JoinUs from './joinUs'

export default {
  components: {
    Common,
    ZpTypeNav,
    Product,
    Welfare,
    Activity,
    Hvideo,
    JoinUs
  },
  data() {
    return {
      isShowVideo: false
    }
  }
}
</script>

<style lang="scss" scoped>
.jin {
  &-m {
    &-index {
      background: rgba(19, 20, 21, .7);
      // background-image: url('~@/assets/index/back-m.png');
      background-repeat: no-repeat;
      background-size: cover;

      &-check {
        font-size: 13px;
        color: #4777f4;
        line-height: 18px;
        text-align: center;
        margin-top: 129px;

        i {
          font-size: 13px;
          margin-left: 2px;
        }
      }
    }
  }

  /deep/ &-index {
    &-con {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 136px 43px 72px;
      min-height: calc(100vh - 43px);
      background: url('~@/assets/index/home-bg.jpg') no-repeat;
      background-size: cover;
      .bottom-arrow {
        position: relative;
        height: 47px;
        text-align: center;
        .float-Y {
          position: absolute;
          left: 50%;
          transform:translateX(-50%);
          width: 27px;
          height: 27px;
          animation: floatY 1s infinite;
        }
        div {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 0;
          font-size: 12px;
          font-family: PingFangSC-Semibold, PingFang SC;
          color: #FFFFFF;
        }
        .video-play {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 45px;
          height: 45px;
        }
      }
    }

    &-title {
      h1 {
        line-height: 38px;
        font-size: 26px;
        margin-bottom: 5px;
        letter-spacing: 1px;
        font-weight: 600;
      }

      p {
        font-size: 11px;
        letter-spacing: 7px;

        &::before,
        &::after {
          width: 52px;
          height: 5px;
        }

        &::before {
          left: 40px;
        }

        &::after {
          right: 40px;
        }
      }
    }

    &-search {
      width: 308px;
      height: 40px;
      margin-top: 43px;

      .el-input {
        input {
          box-shadow: 0 3px 7px 0 rgba(236, 239, 249, 0.26);
          border-radius: 20px;
        }
      }

      p {
        box-shadow: 0 3px 7px 0 rgba(236, 239, 249, 0.26);
        border-radius: 20px;
        padding-left: 18px;
        font-size: 14px;
        box-sizing: border-box;
      }

      span {
        right: 3px;
        width: 34px;
        height: 34px;

        i {
          font-size: 18px;
        }
      }
    }

    &-desc {
      margin-top: 40px;
      width: 263px;

      p {
        font-size: 11px;
        line-height: 24px;
      }

      p:nth-of-type(1) {
        margin-bottom: 13px;
      }
    }
  }
}
@keyframes floatY {
  0% {
    transform: translate(-50%,0);
  }

  50% {
    transform: translate(-50%,-8px);
  }

  100% {
    transform: translate(-50%,0);
  }
}
</style>
